import { AgGridReact, AgGridReactProps } from 'ag-grid-react'
import { RefObject } from 'react'
import { elasticTheme } from '../aggrid-theme'

type TProps = AgGridReactProps & {
  borderless?: boolean
  gridRef?: RefObject<AgGridReact<any>>
}
export function ThemedAgGrid(props: TProps) {
  const { theme, borderless, gridRef, ...rest } = props
  let appliedTheme = elasticTheme
  if (borderless) {
    appliedTheme = elasticTheme.withParams({
      wrapperBorderRadius: 0,
      wrapperBorder: false,
    })
  }
  return <AgGridReact theme={appliedTheme} {...rest} ref={gridRef} />
}
